
import React, { useEffect, useState } from "react";

const DownloadPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
      setShowPopup(true); // show popup when PWA prompt is available
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = (e) => {
    e.preventDefault();
    if (!promptInstall) return;
    promptInstall.prompt();
  };

  if (!supportsPWA || !showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="close-btn" onClick={() => setShowPopup(false)}>
          ✕
        </button>
        <img
          src="/images/addanew.png"
          alt="App Logo"
          className="popup-logo"
        />
        <h3 className="popup-title">Download Our App</h3>
        <button className="download-btn" onClick={handleInstall}>
          DOWNLOAD APP <img src="/images/dowloadIcon.png" alt="" />
        </button>
      </div>
    </div>
  );
};

export default DownloadPopup;
